jQuery(document).ready(function($) {
  if ($(".FAQContainer").length) {
    console.log("FAQ Page");

    $(".accordion-toggle").on("click", function(e) {
      e.preventDefault();
      $(this).toggleClass("collapsed");
      $(this)
        .parents(".panel.panel-default")
        .find(".panel-collapse")
        .slideToggle();
    });
  }
});
